import { computed, onMounted, ref } from 'vue';
import { debounceTime, tap } from 'rxjs/operators';
import { useAppModeStore } from 'src/stores/appMode';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
import { AppGeneralVariables } from 'src/plugins/general/variables';
/**
 * Plugin containing method to update
 * if current user is typing in the firestore
 */
const ChatStylePlugin = () => {
    const { styleType } = AppGeneralVariables();
    const contentRef = ref(null);
    /**
     * Get the display width of the image
     * so that we can calulate the height
     * of the place holder using the aspect ratio
     */
    const imageWidth = ref(0);
    const { subject: getImageWh$ } = rxInitSubjectCallback();
    useObservable(getImageWh$.pipe(debounceTime(300), tap(() => {
        imageWidth.value = (7 / 12) * ((contentRef.value?.offsetWidth || 0) - 8) - 16;
    })));
    onMounted(() => {
        getImageWh$.next('');
    });
    /**
     * Chat input height and
     * the balancing act with the chat area
     */
    const chatInputHeight = ref(40);
    const appModeStore = useAppModeStore();
    const chatAreaHeightClass = computed(() => {
        const keyboardPreShowHt = appModeStore.keyboardPreShowHt;
        let classStr = `chat-area-ht-${styleType.value === 'mobile'
            ? 'mobile'
            : keyboardPreShowHt > 0
                ? 'app-desk-keyboard'
                : 'app-desk'}`;
        const chatInputHeightList = [
            50, 68, 86, 104, 122, 140
        ];
        /**
         * Find the appropriate height class
         */
        for (let i = 0; i < chatInputHeightList.length; i++) {
            const nextIndex = i + 1;
            if (nextIndex <= chatInputHeightList.length - 1) {
                if ((chatInputHeight.value >= chatInputHeightList[i]) &&
                    (chatInputHeight.value < chatInputHeightList[nextIndex])) {
                    classStr += `-${nextIndex}`;
                    break;
                }
            }
            else if (chatInputHeight.value >= chatInputHeightList[i]) {
                classStr += `-${nextIndex}`;
                break;
            }
        }
        return {
            [classStr]: true
        };
    });
    function updateInputHeight(height) {
        chatInputHeight.value = height;
    }
    return {
        imageWidth,
        contentRef,
        chatInputHeight,
        chatAreaHeightClass,
        updateInputHeight
    };
};
export { ChatStylePlugin };
